import React from 'react';
import KnaekPrimaryButton from "../../AppComponents/KnaekPrimaryButton";
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";
import {useHandleLinkClick} from "../../../hooks/useHandleLinkClick";


export default function Section4and5ForCompanies() {
    const handleLinkClick = useHandleLinkClick();


    const initStrings = {
        buttonText: stringsTranslate(appWords.contact_us),
        headingSection1: stringsTranslate(appWords.building_together),
        subheadingSection1_1: stringsTranslate(appWords.power_of_collaboration_description),
        subheadingSection1_2: stringsTranslate(appWords.discount_partners_expectations_intro),
        subheadingSection1_3: stringsTranslate(appWords.display_qr_code),
        subheadingSection1_4: stringsTranslate(appWords.encourage_favorites),
        playImg1: "/assets/images/ForCompanies/Abri 1.webp",

        headingSection2: stringsTranslate(appWords.how_couponing_works),
        playImg2: "/assets/images/ForCompanies/image 3.webp",
    }

    return (
        <section className="section ">
            <div className="container-fluid ">

                {/*Section 4*/}
                <div
                    className="row mt-5 justify-content-center align-items-center px-2 px-md-5 px-lg-5 py-md-5 py-lg-5 py-4">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center button-4-5-section">
                        <KnaekPrimaryButton
                            onClick={() => handleLinkClick("/contact")}
                            title={initStrings.buttonText}
                        />
                    </div>

                    <div className="col-lg-6 col-md-12 flex-wrap d-flex align-items-center mt-5 list">
                        <h2 className="pr-0 pr-md-5 pr-lg-5 mr-0 mr-lg-5 mr-md-5 text-left">{initStrings.headingSection1}</h2>

                        <p className="mt-2 p-1 line-text">{initStrings.subheadingSection1_1}</p>
                        <p className="mt-2 p-1 line-text">{initStrings.subheadingSection1_2}</p>
                        <ul>
                            <li className={"ml-3 line-text"}>
                                <p>{initStrings.subheadingSection1_3}</p>
                            </li>
                            <li className={"ml-3 line-text"}>
                                <p>{initStrings.subheadingSection1_4}</p>
                            </li>
                        </ul>
                    </div>

                    <div className="col-lg-6 col-md-12 text-center d-none d-lg-inline">
                        <img src={initStrings.playImg1} className={"w-50"} alt={""}/>
                    </div>
                </div>

                {/*Section 5*/}

                <div className="row section5-for-companies justify-content-center align-items-center px-0 px-lg-5 px-md-5 mt-0 mt-lg-5 mt-md-5 pb-4 pb-lg-5 pb-md-5">
                    <div className="col-lg-12 col-md-12 text-center mt-3 ">
                        <h3 className={"pt-0 pt-lg-3 pt-md-3 d-none d-md-inline"}>
                            <a className={"p-1 line-text border-bottom border-dark cursor-pointer"}
                               onClick={() => goToYouTube()}>{initStrings.headingSection2}</a>
                        </h3>
                        <h6 className={"pt-0 pt-lg-3 pt-md-3 d-block d-md-none"}>
                            <a className={"p-1 line-text border-bottom border-dark cursor-pointer"}
                               onClick={() => goToYouTube()}>{initStrings.headingSection2}</a>
                        </h6>
                        <img src={initStrings.playImg2}
                             className={"radius-15 w-100 cursor-pointer px-1 mt-3 mt-lg-4 mt-md-4"} alt={""}
                             onClick={() => goToYouTube()}/>

                    </div>
                </div>


            </div>
        </section>
    );

    function goToYouTube() {
        if (window.location.href.toString().includes("give-student-discounts")) {
            window.open('https://www.youtube.com/watch?v=NngjpBjS3ME')

        } else {
            window.open('https://www.youtube.com/watch?v=IcuCt12_VOY')

        }

    }

}
